import CardShuffler from './modules/CardShuffler'
import AnimateSplash from './modules/AnimateSplash'
// import pageTransition from './modules/pageTransition/index'
import copyrightYear from './modules/copyrightYear'
import UnicornCanvas from './modules/UnicornCanvas'
import floatingParticles from './modules/floatingParticles'
import footerNavSlide from './modules/footerNavSlide'
import moveTopAnimation from './modules/moveTopAnimation'
import headerHamburger from './modules/headerHamburger'
import headerOverlapFooter from './modules/headerOverlapFooter'
import headerDropNavigation from './modules/headerDropNavigation'
import elementLoadAnimation from './modules/elementLoadAnimation'
import topColoumSwiper from './pages/index'
import initializeSwiper from './pages/english'
import loadingMoreCol from './modules/loadingMoreCol'
// import loadingMoreEnCol from './modules/loadingMoreEnCol'
import loadingMoreCsr from './modules/loadingMoreCsr'
import columnImg from './modules/columnImg'

// // ヘルパー関数のインポート
import { updateHtml } from './modules/pageTransition/helpers'

import { isExist } from './utilities/isExist'

function getCurrentView() {
    const path = window.location.pathname
    if (path === '/' || path.startsWith('/home')) {
        return 'home'
    } else if (path.includes('/english')) {
        return 'english'
    }
    return 'other'
}

export default function init() {
    // create card shuffler
    if (isExist('.-js-card-shuffle')) {
        new CardShuffler('.-js-card-shuffle')
    }

    // animate splash
    if (isExist('.-js-splash')) {
        new AnimateSplash('.-js-splash')
    }

    // page Transition
    // pageTransition()

    const view = getCurrentView()
    updateHtml(view)

    // add floating particles
    if (!isExist('.hero')) {
        floatingParticles()
    }

    // add footer unicorn animation
    if (!document.querySelector('.unicorn').classList.contains('-is-disabled')) {
        new UnicornCanvas('/img/unicorn.png', 'unicorn')
    }

    footerNavSlide()
    
    // add copyright year
    copyrightYear()

    if (isExist('.fade-in-element')) {
        new elementLoadAnimation()
    }

    if (isExist('.swiper-wrapper')) {
        topColoumSwiper()
        initializeSwiper()
    }

    if (isExist('#btn-more-col')) {
        loadingMoreCol()
    }

    // if (isExist('#btn-more-col-en')) {
    //     loadingMoreEnCol()
    // }

    if (isExist('#btn-more-csr')) {
        loadingMoreCsr()
    }

    if (isExist('.column__article-inner')) {
        columnImg()
    }
}

document.addEventListener('DOMContentLoaded', () => {
    init()
})

moveTopAnimation()
headerHamburger()
headerDropNavigation()
headerOverlapFooter()
